export default {
      id: "ic_appli-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_appli-usage",
      toString: function () {
        return this.url;
      }
    }